
const state = {
  id: null,
  field_type: 'input',
  hint: '',
  key: '',
  label: '',
  options: {
    default_value: '',
    export: {
      reaxml: {
        path: '',
      },
    },
    import: {
      reaxml: {
        path: '',
        path_type: 'xpath',
      },
    },
    input_type: '',
  },
  owner_id: undefined,
  owner_type: '',
  placeholder: '',
  required: false,
  sort: null,
}

export const requiredFields = [
  { key: 'field_type' },
  { key: 'key' },
  { key: 'label' },
  { key: 'owner_id' },
  { key: 'owner_type' },
]

export default state
